export enum CpxApiErrorCodeDmpConnectJs2Enum {
    'ErrTechnical' = 1,
    'ErrFunctional' = 2,
    'ErrInvalidSession' = 3,
}
